import * as i0 from '@angular/core';
import { Pipe } from '@angular/core';
const GARMIN_CDN_URL = 'https://static.garmincdn.com';

/**
 * Fly-Possessive-Noun - Pipe to add the 's on nouns
 * (ie. Patrick -> Patrick's, Chris -> Chris')
 *
 * @example Basic usage
 * {{ name | flyPossessiveNoun }}
 */
let PossessiveNounPipe = /*#__PURE__*/(() => {
  class PossessiveNounPipe {
    transform(value) {
      return value + (value.toLocaleLowerCase().slice(-1) !== 's' ? "'s" : "'");
    }
    static {
      this.ɵfac = function PossessiveNounPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PossessiveNounPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "flyPossessiveNoun",
        type: PossessiveNounPipe,
        pure: true
      });
    }
  }
  return PossessiveNounPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
var AvcCoreDataBaseUrl = /*#__PURE__*/function (AvcCoreDataBaseUrl) {
  AvcCoreDataBaseUrl["LOCAL"] = "https://avc-coredata-test.garmin.com";
  AvcCoreDataBaseUrl["DEV"] = "https://avc-coredata-dev.garmin.com";
  AvcCoreDataBaseUrl["TEST"] = "https://avc-coredata-test.garmin.com";
  AvcCoreDataBaseUrl["STAGE"] = "https://avc-coredata-stg.garmin.com";
  AvcCoreDataBaseUrl["PROD"] = "https://avc-coredata.garmin.com";
  return AvcCoreDataBaseUrl;
}(AvcCoreDataBaseUrl || {});
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
var ServicesBaseUrl = /*#__PURE__*/function (ServicesBaseUrl) {
  ServicesBaseUrl["LOCAL"] = "https://avcloud-api-test.garmin.com";
  ServicesBaseUrl["DEV"] = "https://avcloud-api-dev.garmin.com";
  ServicesBaseUrl["TEST"] = "https://avcloud-api-test.garmin.com";
  ServicesBaseUrl["STAGE"] = "https://avcloud-api-stg.garmin.com";
  ServicesBaseUrl["PROD"] = "https://avcloud-api.garmin.com";
  return ServicesBaseUrl;
}(ServicesBaseUrl || {});
var FlyGarminBaseUrl = /*#__PURE__*/function (FlyGarminBaseUrl) {
  FlyGarminBaseUrl["LOCAL"] = "https://localhost.garmin.com:8443";
  FlyGarminBaseUrl["DEV"] = "https://flydev.garmin.com";
  FlyGarminBaseUrl["TEST"] = "https://flytest.garmin.com";
  FlyGarminBaseUrl["STAGE"] = "https://flystg.garmin.com";
  FlyGarminBaseUrl["PROD"] = "https://fly.garmin.com";
  return FlyGarminBaseUrl;
}(FlyGarminBaseUrl || {});
var FlyGarminLegacyBaseUrl = /*#__PURE__*/function (FlyGarminLegacyBaseUrl) {
  FlyGarminLegacyBaseUrl["LOCAL"] = "https://localhost.garmin.com:8443/fly-garmin";
  FlyGarminLegacyBaseUrl["DEV"] = "https://flydev.garmin.com/fly-garmin";
  FlyGarminLegacyBaseUrl["TEST"] = "https://flytest.garmin.com/fly-garmin";
  FlyGarminLegacyBaseUrl["STAGE"] = "https://flystg.garmin.com/fly-garmin";
  FlyGarminLegacyBaseUrl["PROD"] = "https://fly.garmin.com/fly-garmin";
  return FlyGarminLegacyBaseUrl;
}(FlyGarminLegacyBaseUrl || {});
var FlyAdminBaseUrl = /*#__PURE__*/function (FlyAdminBaseUrl) {
  FlyAdminBaseUrl["LOCAL"] = "https://localhost.garmin.com:9443";
  FlyAdminBaseUrl["DEV"] = "https://flyadmin-dev.aviation.garmin.com";
  FlyAdminBaseUrl["TEST"] = "https://flyadmin-test.aviation.garmin.com";
  FlyAdminBaseUrl["STAGE"] = "https://flyadmin-stage.aviation.garmin.com";
  FlyAdminBaseUrl["PROD"] = "https://flyadmin.aviation.garmin.com";
  return FlyAdminBaseUrl;
}(FlyAdminBaseUrl || {});
var FlyAdminLegacyBaseUrl = /*#__PURE__*/function (FlyAdminLegacyBaseUrl) {
  FlyAdminLegacyBaseUrl["LOCAL"] = "https://localhost.garmin.com:9443/flyadmin";
  FlyAdminLegacyBaseUrl["DEV"] = "https://flyadmin-dev.aviation.garmin.com/flyadmin";
  FlyAdminLegacyBaseUrl["TEST"] = "https://flyadmin-test.aviation.garmin.com/flyadmin";
  FlyAdminLegacyBaseUrl["STAGE"] = "https://flyadmin-stage.aviation.garmin.com/flyadmin";
  FlyAdminLegacyBaseUrl["PROD"] = "https://flyadmin.aviation.garmin.com/flyadmin";
  return FlyAdminLegacyBaseUrl;
}(FlyAdminLegacyBaseUrl || {});
var FGBaseUrl = /*#__PURE__*/function (FGBaseUrl) {
  FGBaseUrl["LOCAL"] = "";
  FGBaseUrl["DEV"] = "https://dev.fg.garmin.com";
  FGBaseUrl["TEST"] = "https://test.fg.garmin.com";
  FGBaseUrl["STAGE"] = "https://stg.fg.garmin.com";
  FGBaseUrl["PROD"] = "https://fg.garmin.com";
  return FGBaseUrl;
}(FGBaseUrl || {});
const generateUniqueId = () => Date.now().toString(36) + Math.random().toString(36).slice(2);

/**
 * Generated bundle index. Do not edit.
 */

export { AvcCoreDataBaseUrl, FGBaseUrl, FlyAdminBaseUrl, FlyAdminLegacyBaseUrl, FlyGarminBaseUrl, FlyGarminLegacyBaseUrl, GARMIN_CDN_URL, PossessiveNounPipe, ServicesBaseUrl, generateUniqueId };
